import router from "../index";

export default function guest({next, store}) {
    // console.log(store.getters.auth);
    let user = store.getters.getUser;
    if (user) {
        if (user.type === 'admin') {
            router.push({
                name: 'UserDashboard'
            });
        } else if (user.type === 'client') {
            router.push({
                name: "ClientDashboard"
            })
        }
    }
    return next()
}